import React from 'react';

import './Board.scoped.scss';

const Board: React.FC<{ url: string }> = ({ url }) => {
  return (
    <div className="board ">
      <iframe
        id="live-class-main-window"
        allow="microphone *; camera *; allowfullscreen;"
        src={url}
      ></iframe>
    </div>
  );
};

export default Board;

// from-akka-apps-redis-channel
